/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from 'react';
import { Dropdown, Badge, Button, Empty } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { useBoolean, useInterval, useRequest, useUpdateEffect } from 'ahooks';
import { BellOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import api from './api';
import { getStationID } from 'utils/cookie';

const cookieStationId = getStationID();

const salaryPlanJumpObj = {
  default: {
    customer_group_id: -1,
    work_content_id: -1,
    status: -1,
    is_export: 0,
  },
  pathName: '/site/payrollManage',
};

const rateJumpObj = {
  default: {
    empType: '',
    paidType: '',
    status: '',
  },
  pathName: '/site/rate',
};

const staffSalary = {
  default: {
    empType: '',
    status: '',
  },
  pathName: '/site/staffSalary',
};

const jumpTypeMap = {
  2: salaryPlanJumpObj,
  1: salaryPlanJumpObj,
  3: salaryPlanJumpObj,
  7: staffSalary,
  8: staffSalary,
  9: rateJumpObj,
  10: rateJumpObj,
  11: rateJumpObj,
};

const getTimeShow = (timestamp) => {
  const time = moment(timestamp * 1000);
  const duration = Math.abs(time.diff(moment(), 'hours'));
  if (duration >= 1) {
    if (duration >= 24) {
      return `${time.format('YYYY.MM.DD')}`;
    }
    return `${Math.abs(time.diff(moment(), 'hours'))}小时前`;
  }
  return `${Math.abs(time.diff(moment(), 'minutes'))}分钟前`;
};

const Index = (props) => {
  const { accountInfo, currentStation } = props;
  const [state, { setTrue, toggle }] = useBoolean(false);
  const onClickShow = useCallback(() => setTrue(), []);
  const [msgList, setMsglist] = useState([]);
  const [unreadNum, setUnreadNum] = useState(0);

  const unReadNumService = useRequest((params) => api.getUnread(params), {
    manual: true,
    onSuccess: (data) => setUnreadNum(data),
  });

  useInterval(() => {
    if (accountInfo?.accountId && currentStation)
      unReadNumService.run({ accountId: accountInfo.accountId });
  }, 60000);

  const getMsgList = useRequest((params) => api.getMsgList(params), {
    manual: true,
    onSuccess: (data) => setMsglist(data),
  });

  useEffect(() => {
    if (state) {
      getMsgList.run({ accountId: accountInfo?.accountId });
    }
  }, [state]);

  useUpdateEffect(() => {
    if (currentStation && accountInfo?.accountId && cookieStationId)
      unReadNumService.run({ accountId: accountInfo.accountId });
  }, [currentStation, accountInfo, cookieStationId]);

  const readMsg = useRequest((params) => api.readMsg(params), {
    manual: true,
    onSuccess: () => {
      getMsgList.run({ accountId: accountInfo.accountId });
      unReadNumService.run({ accountId: accountInfo.accountId });
    },
  });

  const jump = (item) => {
    const queryObj = JSON.parse(item.queryStr);
    const defaultParams = { ...(jumpTypeMap[item.type]?.default || {}), ...queryObj };
    const query = Object.entries(defaultParams).reduce(
      (p, c) => `${p}${p === '?' ? '' : '&'}${c[0]}=${c[1]}`,
      '?',
    );
    window.open(`${jumpTypeMap[item.type]?.pathName}${query}`, '_blank');
    toggle();
  };

  const readMsgFn = (item) => {
    readMsg.run({
      id: item.id,
      accountId: accountInfo.accountId,
      readAll: 0,
    });
  };

  const viewDetial = (item) => {
    if (!item.isRead) readMsgFn(item);
    jump(item);
  };

  const content = (
    <div className={styles.noticeContent}>
      <div className="header">
        <span>全部消息</span>
        <Button
          type="link"
          onClick={() =>
            readMsg.run({
              accountId: accountInfo.accountId,
              readAll: 1,
            })
          }
        >
          一键已读
        </Button>
      </div>
      <div className="main">
        {getMsgList.loading ? null : msgList.length === 0 ? (
          <Empty description={<span>暂无消息</span>} />
        ) : (
          msgList.map((item) => (
            <div key={item.id} className={item.isRead ? 'msg isRead' : 'msg'}>
              <span className="type">[{item.typeName}]</span>
              <span className="text">{item.content}</span>
              <div className="footer">
                <span className="time">{getTimeShow(item.createTime)}</span>
                <div className="btns">
                  <div
                    className="view-detail"
                    onClick={() => viewDetial(item)}
                    role="button"
                    tabIndex="0"
                  >
                    查看详情
                  </div>
                  <div
                    className="i-see"
                    onClick={item.isRead ? null : () => readMsgFn(item)}
                    role="button"
                    tabIndex="0"
                  >
                    知道了
                  </div>
                </div>
              </div>
              <div className="border" />
            </div>
          ))
        )}
      </div>
    </div>
  );

  return (
    <>
      <Dropdown onVisibleChange={toggle} visible={state} trigger={['click']} overlay={content}>
        <Badge count={unreadNum} size="small">
          <BellOutlined className="notice-bell" onClick={onClickShow} />
        </Badge>
      </Dropdown>
    </>
  );
};

const mapStateToProps = (state) => {
  const { basic } = state;
  return {
    ...basic,
  };
};

export default connect(mapStateToProps)(withRouter(Index));
